export const ERR_CODES = {
  Success: 0,
  ErrorProcessing: 1,
  ErrorNoMember: 1000,
  ErrorWrongPW: 1001,
  ErrorLock: 1002,
  ErrorAuthMsgTime: 1003,
  ErrorNumberWrong: 1004,
  ErrorNumber3Wrong: 1006,
  ErrorNoNumber: 1007,
  ErrorMember: 1008,
  ErrorSuccessMsg: 1010,
  ErrorPartner: 1011,
  ErrorNoCaptchaToken: 1012,
  ErrorNoTel: 1020,
  ErrorTel: 1021,
  ErrorWrongTel: 1025,
  SuccessDelMember: 1030,
  ErrorAuthMsgTimeout: 1031,
  ErrorAuthMsgNumberWrong: 1032,
  ErrorAuthMsgNumber3Wrong: 1033,
  ErrorCaptchaWrong: 1035,
  ErrorCaptcha3Wrong: 1036,
  ErrorFamilyMemberDel: 1037,
  SuccessCaptcha: 1038,
  ErrorCaptchaTime: 1039,
  ErrorCaptchaTimeOut: 1040,
  ErrorInvalidAccess: 1070,    
  ErrorAccessRestricted: 1071,
  ErrorNonCmd: 9000,
  ErrorSession: 9001,
} as const
